
define(
	'C3.PDPSerialLotFunctionality.SerialLotData'
,   [
		'C3.PDPSerialLotFunctionality.SerialLotData.View'
	,   'underscore'
	]
,   function (
		SerialLotDataView
	,   _
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// isSerialLotPDP context is now added via ShoppingExtensionsLatest PDP module
			// in ProductDetailsImageGalleryView.prototype.getContext
		}
	};
});
